import userauth from '~/helpers/userauth'

export default async (to, from, next) => {
    if (!userauth.isLoggedIn()) {
        next({name: 'login'})
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js